import React from 'react';

const Connector = ({ id, from, to, points }) => {
  const calculatePath = () => {
    if (points && points.length > 0) {
      let path = `M ${from.x} ${from.y}`;
      points.forEach(point => {
        path += ` L ${point.x} ${point.y}`;
      });
      path += ` L ${to.x} ${to.y}`;
      return path;
    }
    return `M ${from.x} ${from.y} L ${to.x} ${to.y}`;
  };

  return (
    <svg className="connector" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none' }}>
      <path
        d={calculatePath()}
        stroke="#000"
        strokeWidth="2"
        fill="none"
        markerEnd="url(#arrowhead)"
      />
      <defs>
        <marker id="arrowhead" markerWidth="10" markerHeight="7" refX="9" refY="3.5" orient="auto">
          <polygon points="0 0, 10 3.5, 0 7" fill="#000" />
        </marker>
      </defs>
    </svg>
  );
};

export default Connector;